import React from 'react';

const AutoComplete = (props) => {
    return 'CONTENT';
};

export default AutoComplete;
